
  <div class="wrapper">
    <div id="map"></div>
    <svg
        version="1.1"
        class="marker"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="25.1px"
        height="40.228px"
        viewBox="403.95 503.062 25.1 40.228"
        enable-background="new 403.95 503.062 25.1 40.228"
        xml:space="preserve"
    >
			<text style="font: italic 20px serif; fill: #000">Pilne!</text>
      <rect x="410.279" y="507.574" fill="#FFFFFF" width="12.625" height="14.5" />
      <linearGradient
          id="SVGID_1_"
          gradientUnits="userSpaceOnUse"
          x1="436.9465"
          y1="487.176"
          x2="436.9465"
          y2="524.7421"
          gradientTransform="matrix(1 0 0 -1 -20.4463 1028.1743)"
      >
				<stop offset="0" style="stop-color: #126fc6" />
        <stop offset="1" style="stop-color: #4c9cd1" />
			</linearGradient>
      <linearGradient
          id="SVGID_2_"
          gradientUnits="userSpaceOnUse"
          x1="345.3665"
          y1="505.6882"
          x2="345.3665"
          y2="524.7412"
          gradientTransform="matrix(1 0 0 -1 71.1338 1028.1743)"
      >
				<stop offset="0" style="stop-color: #2e6c97" />
        <stop offset="1" style="stop-color: #3883b7" />
			</linearGradient>
      <path
          fill="url(#SVGID_1_)"
          stroke="url(#SVGID_2_)"
          stroke-width="1.1"
          stroke-linecap="round"
          d="M416.544,503.612
        c-6.573,0-12.044,5.691-12.044,11.866c0,2.778,1.563,6.308,2.693,8.746l9.307,17.872l9.262-17.872
        c1.13-2.438,2.738-5.791,2.738-8.746C428.5,509.303,423.116,503.612,416.544,503.612L416.544,503.612z M416.544,510.767
        c2.584,0.017,4.679,2.122,4.679,4.71s-2.095,4.663-4.679,4.679c-2.584-0.017-4.68-2.09-4.68-4.679
        C411.865,512.889,413.96,510.783,416.544,510.767z"
      />
      <path
          fill="none"
          stroke="#FFFFFF"
          stroke-width="1.1"
          stroke-linecap="round"
          stroke-opacity="0.122"
          d="M416.531,504.719
        c-5.943,0-10.938,5.219-10.938,10.75c0,2.358,1.442,5.832,2.563,8.25l0.031,0.03l8.313,15.97l8.25-15.97l0.03-0.03
        c1.136-2.448,2.625-5.706,2.625-8.25C427.406,509.931,422.475,504.719,416.531,504.719z M416.531,509.688
        c3.168,0.021,5.781,2.601,5.781,5.781c0,3.18-2.613,5.761-5.781,5.78c-3.168-0.02-5.75-2.609-5.75-5.78
        C410.781,512.297,413.363,509.708,416.531,509.688z"
      />
		</svg>
    <map-legend
        :mode="mode"
        :route-color="legendRouteColor"
        :has-permanent-points="hasPermanentPlanningPoints"
        :has-selected-points="selectedPointKeys.length > 0"
    />
  </div>
